//-- Filters

Vue.filter('dateFormat', function (date) {
    return moment(date).format('DD/MM/YYYY');
});

Vue.filter('dateToDay', function (date) {
    return moment(date).format('dddd');
});

Vue.filter('orderTypeToLabel', function (key) {
    var word = key.toLowerCase().split('_').join('-');
    return word.charAt(0).toUpperCase() + word.slice(1);
});

Vue.filter('dayToLabel', function (key) {
    var word = key.toLowerCase(); // All string in lowercase
    return word.charAt(0).toUpperCase() + word.slice(1); // First letter capitalized
});

Vue.filter('slotToETA', function (key, arrival) {
    var slots = key.split('_');

    var values = [];
    $.each(slots, function (index, slot) {
        var value = slot.padStart(2, '0'); // Add a pad by 0, ex : 6 = 06
        if (value.length == 2) value = value + ':00'; // Format for plain hour, ex: 06 = 06:00
        if (value.length == 4) value = 0 + value; // Format for decimal under 10, ex: 9:30 = 09:30

        values.push(value);
    });

    arrival = arrival + '';
    return values[0].replace(':00', '') + ':' + arrival.padStart(2, 0);
});

Vue.filter('setDecimals', function (value) {
    return (Math.round(value * 100) / 100).toFixed(2);
});

Vue.filter('statusToLabel', function (key) {

    switch (key) {
        case 'NEW':
            return "Pending";
        case 'FINALIZED':
            return 'Delivered';
        case 'DELIVERY_ISSUE':
            return 'Delivery issue';
        case 'CANCELLED':
            return 'Cancelled';
        case 'CANCELED':
            return 'Cancelled';
        default:
            return 'Unknow';
    }

});


//-- Global variables

Vue.mixin({
    data: function () {
        return {
            get _days() {
                return [
                    {long: 'MONDAY', short: 'M'},
                    {long: 'TUESDAY', short: 'Tu'},
                    {long: 'WEDNESDAY', short: 'W'},
                    {long: 'THURSDAY', short: 'Th'},
                    {long: 'FRIDAY', short: 'F'},
                    {long: 'SATURDAY', short: 'Sa'},
                    {long: 'SUNDAY', short: 'Su'}
                ];
            },

            get _daysOrder() {
                return {
                    "MONDAY": 1,
                    "TUESDAY": 2,
                    "WEDNESDAY": 3,
                    "THURSDAY": 4,
                    "FRIDAY": 5,
                    "SATURDAY": 6,
                    "SUNDAY": 7
                }
            },

        }
    },

    methods: {
        isDateBeforeToday(date) {
            return new Date(date.toDateString()) < new Date(new Date().toDateString());
        }
    }

})
